module.exports = __webpack_public_path__ + "static/epdm-1-8eba063cb38d6696fedc31c7d3383a3c.jpg";